module.exports = __webpack_public_path__ + "img/package-1.b46426da.png";